import { FC, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Icon, { IconNames } from 'components/Icon';
import theme from 'config/theme';
import CoffeeSvg from 'assets/images/coffee.svg';

// Campaign ref is fixed, so this deliberately skips getPathWithRef.
const CLAIM_COFFEE_PATH = '/forms/donor-thanks-2026?ref=post_20260928_personalizedty';

// Dismissal lasts for the current page load only.
export const DonorThanksBanner: FC = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <div className="donor-thanks-banner">
      <span className="donor-thanks-banner-icon">
        <img src={CoffeeSvg} alt="" />
      </span>
      <h2 className="h4-text semi-bold donor-thanks-banner-title">
        A small thank you for a big difference!
      </h2>
      <RouterLink className="button button-brand donor-thanks-banner-claim" to={CLAIM_COFFEE_PATH}>
        Claim your coffee
      </RouterLink>
      <button
        type="button"
        className="button donor-thanks-banner-dismiss"
        aria-label="Dismiss"
        onClick={() => setIsDismissed(true)}
      >
        <Icon name={IconNames.XClose} size={18} color={theme.colors.inkBlue} />
      </button>
    </div>
  );
};
